import React from "react";

interface HamburgerProps {
	func(e: React.MouseEvent): void;
}

function Hamburger({func}: HamburgerProps): JSX.Element {
	return (
		<div className="cursor-pointer lg:hidden" onClick={func}>
			<div>
				<div className="h-0.5 w-6 rounded-full bg-black-secondary" />
				<div className="mt-1 h-0.5 w-6 rounded-full bg-black-secondary" />
				<div className="mt-1 h-0.5 w-6 rounded-full bg-black-secondary" />
			</div>
		</div>
	);
}

export default Hamburger;
